// @ts-nocheck
import React from 'react';
import MultiSelect from '../../ui/inputs/MultiSelect';
import Tooltip from '../../ui/Tooltip';
import type { Language } from '../../../config/localization';

interface MultiselectOption {
  value: string;
  label: string;
}

interface MultiselectConfig {
  options: MultiselectOption[];
  placeholder?: string;
  maxItems?: number;
}

interface DynamicMultiselectProps {
  fieldId: string;
  label: string;
  description?: string;
  tooltip?: string;
  value: string[];
  onChange: (value: string[]) => void;
  config: MultiselectConfig;
  isRequired?: boolean;
  error?: string;
  language: Language;
}

export default function DynamicMultiselect({
  fieldId,
  label,
  description,
  tooltip,
  value,
  onChange,
  config,
  isRequired,
  error,
  language
}: DynamicMultiselectProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label htmlFor={fieldId} className="text-xs font-medium text-gray-300">
          {label}
          {isRequired && <span className="text-red-400 ml-1">*</span>}
          {config.maxItems && (
            <span className="text-gray-500 ml-2 text-xs">
              (max {config.maxItems})
            </span>
          )}
        </label>
        {tooltip && (
          <Tooltip content={tooltip}>
            <div className="w-4 h-4 bg-gray-700/50 border border-gray-600 rounded-full flex items-center justify-center cursor-help hover:bg-gray-600/50 transition-colors duration-200">
              <span className="text-xs text-gray-300 font-medium">?</span>
            </div>
          </Tooltip>
        )}
      </div>
      
      {description && (
        <p className="text-xs text-gray-400">{description}</p>
      )}
      
      <MultiSelect
        options={config.options}
        value={value}
        onChange={(newValue) => {
          if (config.maxItems && newValue.length > config.maxItems) {
            return;
          }
          onChange(newValue);
        }}
        placeholder={config.placeholder || 'Select options...'}
        className="w-full"
        id={fieldId}
        language={language}
      />
      
      {error && (
        <p className="text-xs text-red-400">{error}</p>
      )}
    </div>
  );
}
